export interface NavLink {
  label: string;
  href: string;
  active?: boolean;
}

export function resolveNavLinksForViewer(links: NavLink[], isSignedIn: boolean): NavLink[] {
  if (isSignedIn) return links;

  let changed = false;
  const mapped = links.map((link) => {
    if (link.href !== '/models') return link;
    changed = true;
    return { ...link, href: '/models/apply' };
  });

  return changed ? mapped : links;
}
